import { ImageSourceSizes } from '@ag1/ui';
import clsx from 'clsx';
import StudioResponsiveMedia from 'shared/studio/StudioResponsiveMedia/StudioResponsiveMedia';
import { HeroHalfV5 } from 'types/studio/studio';
import styles from './HeroHalfV5Media.module.scss';

type Props = Pick<
  HeroHalfV5,
  'contentPosition' | 'isFullScreenBg' | 'mediaSizeNarrow' | 'media'
> & {
  imageSizes: ImageSourceSizes;
  eagerLoading: boolean;
};

const HeroHalfV5Media = ({
  media,
  contentPosition,
  isFullScreenBg,
  mediaSizeNarrow,
  imageSizes,
  eagerLoading
}: Props) => {
  const shouldApplyImageCls = !mediaSizeNarrow && !isFullScreenBg;

  return (
    <StudioResponsiveMedia
      {...media}
      className={clsx(
        mediaSizeNarrow ? styles.imageContNarrow : styles.imageCont,
        isFullScreenBg && styles.imageContFullScreen
      )}
      childClassName={[
        shouldApplyImageCls && styles.image,
        shouldApplyImageCls && contentPosition === 'left' && styles.imageLeft
      ]}
      eagerLoading={eagerLoading}
      sizes={imageSizes}
    />
  );
};

export default HeroHalfV5Media;
